import * as React from "react";
import { observer } from "mobx-react";

import {
  Grid,
  Typography,
  Tabs,
  Tab,
  Fab,
  withStyles,
} from "@material-ui/core";
import { Add as AddIcon } from "@material-ui/icons";
import LayerAddDevelopment from "./LayerAddDevelopment";
import InputSearch from "common/components/fields/InputSearch";
import { LoginStore } from "modules/login/LoginStore";

import { DevelopmentStore } from "../../DevelopmentStore";
import i18n from "i18n";

const styles = (theme) => ({
  container: {
    backgroundColor: theme.palette.secondary.light,
    borderBottom: "1px solid #f2f2f2",
    height: "64px",
    position: "relative" as any,
  },
  title: {
    lineHeight: "64px",
    fontSize: "16px",
    fontFamily: "Raleway",
  },
  addDevelopment: {
    bottom: "-28px",
    left: "calc(50% - 28px)",
    zIndex: "2" as any,
  },
  tabsRoot: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.dark,
    boxShadow: "unset",
    width: "fit-content",
    fontSize: "12px",
  },
  tabsIndicator: {
    height: 0,
  },
  tabRoot: {
    padding: `0px ${theme.spacing.unit * 2}px`,
    minWidth: "unset",
    border: "unset",
    fontWeight: 500,
    transition: "all 0.3s ease-in",
    "&$tabSelected > :first-child": {
      borderBottom: `3px solid ${theme.palette.primary.light}`,
      fontWeight: 700,
    },
    "&:hover": {
      color: theme.palette.primary.light,
    },
  },
  tabSelected: {
    color: theme.palette.primary.light,
  },
  tabLabelContainer: {
    padding: "0px",
  },
  tabWrapper: {
    height: "63px",
    display: "block",
    lineHeight: "63px",
    fontFamily: "Raleway",
  },
  gridSearch: {
    display: "table",
    height: "100%",
    "& > :first-child": {
      display: "table-cell",
      height: "100%",
      verticalAlign: "middle",
    },
  },
});

type IProps = {
  classes: any;
};

@observer
class SearchHeader extends React.Component<IProps> {
  state = {
    currentTab: 0,
    layerAdd: false,
  };

  handleTabsChange = (event, value) => {
    DevelopmentStore.currentTab = value;
    if (value === 0)
      DevelopmentStore.developmentsView = DevelopmentStore.developmentsSearch;
    else
      DevelopmentStore.developmentsView =
        DevelopmentStore.developmentsFavoritesSearch;
    this.setState({ currentTab: value });
  };
  handleOpenLayerAdd = () => {
    DevelopmentStore.firstLoad = true;
    DevelopmentStore.isEditAddress = false;
    DevelopmentStore.layerAdd = true;
  };

  handleInputChange = (value) => {
    DevelopmentStore.search = value.toLowerCase();
    DevelopmentStore.developmentsSearch = DevelopmentStore.developments.filter(
      (dev) => {
        const devName = dev.data.name.toLowerCase();
        return devName.includes(DevelopmentStore.search.toLowerCase());
      }
    );
    DevelopmentStore.developmentsFavoritesSearch =
      DevelopmentStore.developmentsSearch.filter(
        (dev: any) => dev.data.favorite
      );
    if (DevelopmentStore.currentTab === 0)
      DevelopmentStore.developmentsView = DevelopmentStore.developmentsSearch;
    else
      DevelopmentStore.developmentsView =
        DevelopmentStore.developmentsFavoritesSearch;
  };
  handleCleanFilter = () => {
    DevelopmentStore.search = "";
    DevelopmentStore.developmentsSearch = DevelopmentStore.developments;
    DevelopmentStore.developmentsFavoritesSearch =
      DevelopmentStore.developmentsFavorites;
    if (DevelopmentStore.currentTab === 0)
      DevelopmentStore.developmentsView = DevelopmentStore.developmentsSearch;
    else
      DevelopmentStore.developmentsView =
        DevelopmentStore.developmentsFavoritesSearch;
  };

  render() {
    const { classes } = this.props,
      { currentTab } = this.state,
      tabClasses = {
        root: classes.tabRoot,
        selected: classes.tabSelected,
        labelContainer: classes.tabLabelContainer,
        wrapper: classes.tabWrapper,
      };

    return (
      <Grid container className={classes.container}>
        <LayerAddDevelopment />
        <Grid item xs={2}>
          <Typography
            className={classes.title}
            style={{ textAlign: "left", paddingLeft: "28px" }}
            component="h2"
          >
            {i18n.menu.development}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Tabs
            value={currentTab}
            onChange={this.handleTabsChange}
            classes={{
              root: classes.tabsRoot,
              indicator: classes.tabsIndicator,
            }}
          >
            <Tab
              classes={tabClasses}
              label={i18n.developments.header.all}
              title=""
            />
            {DevelopmentStore.developmentsFavorites.length > 0 && (
              <Tab
                classes={tabClasses}
                label={i18n.developments.header.favorites}
              />
            )}
          </Tabs>
        </Grid>
        <Grid item xs={4} className={classes.gridSearch}>
          <div>
            {DevelopmentStore.developments.length != 0 ? (
              <InputSearch
                disabled={LoginStore.expiredTrial() ? true : false}
                placeholder={i18n.developments.header.search}
                handleChange={this.handleInputChange}
                handleClean={this.handleCleanFilter}
              />
            ) : (
              <InputSearch
                disabled={true}
                placeholder={i18n.developments.header.search}
                handleChange={this.handleInputChange}
                handleClean={this.handleCleanFilter}
              />
            )}
          </div>
        </Grid>
        <Grid item xs={2} style={{ position: "relative" }}>
          <Fab
            onClick={
              LoginStore.expiredTrial() ? () => "" : this.handleOpenLayerAdd
            }
            color="primary"
            className={classes.addDevelopment}
            style={{ position: "absolute" }}
          >
            <AddIcon />
          </Fab>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(SearchHeader);



// WEBPACK FOOTER //
// ./src/modules/development/components/layouts/SearchHeader.tsx